module.exports = __webpack_public_path__ + "static/scale-model-of-downtown-aquarium-in-lakewood-colorado-1b45c43eb0b9fcaa67841188f4af2880.png";